module.exports = __webpack_public_path__ + "static/media/qrcode.b49a3f5d.svg";